import { AxiosRequestConfig } from "axios"
import { LOCAL_STORAGE_KEY, LOCAL_STORAGE_SECURITY_KEY } from "lib"

const getItem = (key: string) => {
  const result = JSON.parse(
    localStorage.getItem(LOCAL_STORAGE_KEY + key) || "{}"
  )
  return Object.keys(result).length === 0 ? undefined : result
}

export const requestInterceptorSuccessCredentials = (
  config: AxiosRequestConfig
) => {
  const token = getItem(LOCAL_STORAGE_SECURITY_KEY) ?? ""

  const REACT_APP_SECURITY_API_KEY = process.env.REACT_APP_SECURITY_API_KEY
  config.headers["Authorization"] = `Bearer ${REACT_APP_SECURITY_API_KEY}`
  config.headers["Token"] = token
  return config
}

export const requestInterceptorErrorSecurityCredentials = (error: any) => {
  return Promise.reject(error)
}
